import React from "react";
import { Link } from "react-router-dom";

const Page403 = () => {
  return (
    <div className="main-wrapper">
      <div className="error-box">
        <h1>403</h1>
        <h3 className="h2 mb-3">
          <i className="fas fa-lock"></i> Access denied
        </h3>
        <p className="h4 font-weight-normal">
          You do not have permission to view this page.
        </p>
        <Link to="/login" className="btn btn-primary">
          Back to Login
        </Link>
      </div>
    </div>
  );
};

export default Page403;
